import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, CardHeader, CircularProgress, Box } from "@mui/material";
import AccountingApi from "../../Classes/API/AccountingApi";
import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import LogsSearch from "./LogsSearch";
import SearchLogsReq from "../../Classes/Models/Requests/Accounting/SearchLogsReq";
import { LanguageContext } from "App";
import Loader from "Loader";
const Index = () => {
  let navigate = useNavigate();

  const [SearchReq, setSearchReq] = useState(new SearchLogsReq());
  const [ResponseData, setResponseData] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [TableDataRows, setTableDataRows] = useState([]);
  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    { Header: translations.sessionWithoutEnteriesid, accessor: "Id", align: "left" },
    { Header: translations.LogsSearchtablType, accessor: "Type", align: "left" },
    { Header: translations.LogsSearchtableUser, accessor: "User", align: "left" },
    { Header: translations.LogsSearchMessage, accessor: "Message", align: "left" },
    { Header: translations.LogsSearchtableTime, accessor: "Time", align: "left" },
    { Header: translations.LogsSearchRoute, accessor: "Route", align: "left" },
    { Header: translations.LogsSearchRequest, accessor: "Request", align: "left" },
    { Header: translations.LogsSearchResponse, accessor: "Response", align: "left" },
  ];

  const MakeTableRow = (log) => {
    return {
      Id: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.id}
        </MDTypography>
      ),
      Type: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.logType}
        </MDTypography>
      ),
      User: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.userName}
        </MDTypography>
      ),
      Message: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.message}
        </MDTypography>
      ),
      Time: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.date}
        </MDTypography>
      ),
      Route: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.route}
        </MDTypography>
      ),
      Request: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.request}
        </MDTypography>
      ),
      Response: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.response}
        </MDTypography>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList?.forEach((Entry) => {
      rows.push(MakeTableRow(Entry));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    if (Object.keys(ResponseData).length > 1) {
      RefreshTable(ResponseData.list);
    }
  }, [ResponseData]);

  useEffect(() => {
    if (Object.keys(ResponseData).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [ResponseData]);

  const onSearch = async () => {
    SearchReq.pagingParams.pageNumber = Page;
    SearchReq.pagingParams.pageSize = 10;
    console.log(SearchReq);
    let res = await AccountingApi.SearchLogs(SearchReq);
    if (res.status === "Success") {
      console.log(res);
      setResponseData(res.data);
      setTotalPages(res.data.totalPages);
    } else {
      Swal.fire({
        icon: "error",
        text: res.status.message,
      });
    }
  };

  useEffect(() => {
    console.log(SearchReq);
    onSearch();
  }, [SearchReq]);

  useEffect(() => {
    onSearch();
  }, [Page]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <LogsSearch setSearchReq={setSearchReq} />
      {loading ? (
        <Loader />
      ) : (
        <Card className="mt-5">
          <MDBox
            mx={4}
            mt={-3}
            py={3}
            px={2}
            sx={{ backgroundColor: "#3560AD" }}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <div className="text-center">
              <MDTypography variant="h6" color="white">
                {translations.LogsSearchtablLogs}
              </MDTypography>
            </div>
          </MDBox>

          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />

          <div className="text-right mx-3 my-4">
            <Pagination
              count={TotalPages}
              color="primary"
              onChange={(e, num) => setPage(num)}
              className="float-right"
            />
          </div>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default Index;
